import type { TagColor } from '@/components/Tag/Tag'

import type { RoomType } from './room-types'

export const roomTypeLabelAndColorMap: Record<RoomType, TagColor> = {
  regular: 'gray',
  gym: 'blue',
  lab: 'orange',
  auditorium: 'violet',
  music: 'green'
}
